import styled from 'styled-components'
import { Box } from '@mui/material'

export const PageContainer = styled(Box)`
  overflow: auto;
  /* Custom, iPhone Retina */
  @media only screen and (min-width: 320px) {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  /* Extra Small Devices, Phones */
  @media only screen and (min-width: 480px) {
    && {
      margin-left: 3rem;
      margin-right: 3rem;
    }
  }

  /* Small laptop (macbook 13inch) */
  @media only screen and (min-width: 900px) {
    && {
      margin-left: 3rem;
      margin-right: 3rem;
    }
  }

  /* Normal Desktops */
  @media only screen and (min-width: 1680px) {
    && {
      margin-left: 15rem;
      margin-right: 15rem;
    }
  }

  /* Large Devices, Wide Screens */
  @media only screen and (min-width: 2560px) {
    && {
      margin-left: 20rem;
      margin-right: 20rem;
    }
  }
`
